import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { Currency } from 'modules/expenses/hooks/useExpensesListPage'

import type { BaseFilterProps } from './types'

type Props = BaseFilterProps & {
  currencies: Currency[]
}
const currencyFilter = ({ source, currencies }: Props) => {
  const options = [...currencies]
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    .sort((cur1, cur2) => (cur1!.priority > cur2!.priority ? 1 : -1))
    .map((currency) => ({
      label: `${currency?.isoCode} - ${currency?.name}`,
      // eslint-disable-next-line no-type-assertion/no-type-assertion
      value: currency?.isoCode as string,
    }))

  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'expensesList.currencyFilter',
    path: 'currency',
    title: i18n.t('expenses_v2.list.header.currency'),
  })
}

export default currencyFilter
